import { useState } from 'react';
import HorizontalNavbar from '../../../components/HorizontalNavbar/HorizontalNavbar';
import SearchCrawlerBulkUpload from './SearchCrawlerBulkUpload/SearchCrawlerBulkUpload';
import SearchCrawlerKickedOffJobs from './SearchCrawlerKickedOffJobs/SearchCrawlerKickedOffJobs';
import SearchCrawlerScheduler from './SearchCrawlerScheduler/SearchCrawlerScheduler';

const SearchCrawlerPortalKickoff = (props) => {
    const [activeKey, setActiveKey] = useState('bulkKickoff');

    const userEmail = props.userEmail;
    const menuItems = [
        { key: 'bulkKickoff', label: 'Bulk Kickoff'},
        { key: 'kickedOffJobs', label: 'Kicked Off Jobs'},
        { key: 'scheduler', label: 'Scheduling'},
    ]
    return(
        <div>
            <HorizontalNavbar menuItems={menuItems} activeKey={activeKey} setActiveKey={setActiveKey}/>
            {activeKey === 'bulkKickoff' && <SearchCrawlerBulkUpload userEmail={userEmail} setActiveKey={setActiveKey}/>}             
            {activeKey === 'kickedOffJobs' && <SearchCrawlerKickedOffJobs userEmail={userEmail}/>}             
            {activeKey === 'scheduler' && <SearchCrawlerScheduler userEmail={userEmail} setActiveKey={setActiveKey}/>}             
        </div>
    );
};

export default SearchCrawlerPortalKickoff;